import { render, staticRenderFns } from "./PlatformIcon.vue?vue&type=template&id=364c5c6f&scoped=true"
import script from "./PlatformIcon.vue?vue&type=script&lang=js"
export * from "./PlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c5c6f",
  null
  
)

export default component.exports